module.exports = __webpack_public_path__ + "static/media/blue_img_b.351918f5.png";